const AuthHeaderLogo = () => {
    return (
        <div className="card-header-logo">
            <div className="app-icon">
                <img
                    src="https://cdn.premierit.com/images/logos/cent/logo-cent-80.png"
                    alt="Centric"
                />
            </div>
        </div>
    );
};

export default AuthHeaderLogo;
